import { formatCommentEnd, formatCommentStart } from './commentMarkers';
import { escapeHtml } from './escapeHtml';
import type { SerializeContext, SerializeOptions } from './serializeOptions';
import { serializeText } from './serializeText';
import type { CastInlineContent } from '../types';

export function serializeInline(
  node: CastInlineContent,
  options: SerializeOptions,
  context: SerializeContext = {}
): string {
  switch (node.type) {
    case 'link': {
      const inner = node.children.map(child => serializeInline(child, options, context)).join('');
      return options.emitLinks ? `<a href="${escapeHtml(node.href)}">${inner}</a>` : inner;
    }
    case 'selectionEnd':
      return '<selection-end/>';
    case 'selectionStart':
      return '<selection-start/>';
    case 'text': {
      const starts = context.commentMarkers?.startsBefore.get(node) ?? [];
      const ends = context.commentMarkers?.endsAfter.get(node) ?? [];
      return [
        ...starts.map(formatCommentStart),
        serializeText(node, options),
        ...ends.map(formatCommentEnd),
      ].join('');
    }
  }
}
